/* eslint-disable no-underscore-dangle */
import axios from 'axios'
import hash from 'object-hash'

export const fetchVersion = (url: string, version: string, checkConfig: boolean): Promise<boolean> =>
  axios
    .request<{ version: string }>({
      method: 'GET',
      url,
    })
    .then((response) => {
      if (checkConfig) {
        const responseHash: string | undefined = response.headers['x-cf-worker-config-version']
        const currentConfig = {
          // @ts-ignore-next-line
          ...(window.__dhlConfig || {}),
          // Unset VERSION and CSP_NONCE to make the hash deterministic
          VERSION: undefined,
          CSP_NONCE: undefined,
        }

        if (responseHash && responseHash !== hash(currentConfig)) {
          return true
        }
      }

      if (response.data.version !== version) {
        return true
      }
      return false
    })
    // When the user is offline and its not registered in navigator.onLine (e.g. its true but there is no connection)
    // then ignore any network errors so that it wont be recorded to Sentry
    // This happens on Android devices (maybe iOs too) when the Wifi goes into sleep mode
    .catch(() => false)
